/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const MergeErrorMessage = styled.div({
  marginTop: `${gridSize()}px`,
  display: 'flex',
  '> span:first-child': {
    marginRight: `${gridSize() / 2}px`,
  },
});

export const InnerButtonText = styled.span<{ isDisabled?: boolean }>(props =>
  props.isDisabled ? 'visibility: hidden' : ''
);

export const TooltipContent = styled.div({
  width: `${gridSize() * 16}px`,
  textAlign: 'center',
});

export const ModalFooter = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  position: 'relative',
  padding: '22px 24px 24px',
});
